import React from "react";
import { useState } from "react";
import OtpInput from "react-otp-input";
import {
  CustomTextInput,
  H1,
  PrimaryCta,
  Image,
  CustomText,
  UnderLinedLinkCta,
} from "../../components";
import Utils from "../../common/utils.js";
import validator from "validator";
import { Link, useNavigate, useParams } from "react-router-dom";
import Core from "../../common/clientSdk";
import { toast } from "react-hot-toast";
import { useTheme } from "styled-components";
// import { useParams } from "react-router-dom";
import { useSnackbar } from "react-simple-snackbar";
import LeftSideSignup from "./leftSideSignup.js";
var email, request_id;
const VerifyEmail = function (props) {
  const [loading, set_loading] = useState(false);
  const [error, setError] = useState(null);
  const [otp, setOtp] = useState("");
  const [requestId, setRequestId] = useState("");
  const [openSnackbar, closeSnackbar] = useSnackbar();
  var navigate = useNavigate();

  const userData = useParams();
  // const { email = {} } = useParams.email;
  let search = window.location.search;
  let params = new URLSearchParams(search);
  email = params.get("email");
  request_id = params.get("request_id");

  /********************************************************************
  Forgot password

  @param {Function} progress_cb - manage status of screen

  No return
  *********************************************************************/
  function postVerifyForgotPassword() {
    var params = {
      request_id: requestId ? requestId : request_id,
      verification_code: otp,
    };

    Core.postVerifyForgotPassword(
      postVerifyForgotPasswordSuccess,
      postVerifyForgotPasswordFailed,
      (status) => {
        set_loading(status);
      },
      params
    );
  }

  function postVerifyForgotPasswordSuccess(response_data) {
    const success = "New password  send your email";
    openSnackbar(success);
    navigate("/login");
  }

  function postVerifyForgotPasswordFailed(errorList) {
    openSnackbar(errorList);
  }

  function forgotPassword(progress_cb) {
    var params = {
      email: email,
    };

    Core.postForgotPassword(
      forgotPasswordSuccess,
      forgotPasswordFailed,
      (status) => {
        set_loading(status);
      },
      params
    );
  }

  function forgotPasswordSuccess(response_data) {
    setRequestId(response_data.response_data.request_id);
    openSnackbar("Send Otp Your Email");
  }

  function forgotPasswordFailed(errorList) {
    openSnackbar(errorList.map((item) => item.m).join(", "));
  }

  /********************************************************************
  Screen Progress

  @param {Boolean} status - true/false

  No return
  *********************************************************************/
  function updateProgress(status) {
    set_loading(status);
  }

  // function showError(message) {
  //   toast.error(message);
  // }

  const sendOtp = (otp) => {
    setOtp(otp);
  };

  return (
    <div className="main-container">
      <div className="content-container">
        <LeftSideSignup />

        {email && (
          <div className="auth-right-container">
            <div className="inner-left-container">
              <div className="inner-left-container-bind">
                <div className="flex-row">
                  <Image
                    source={"../assets/images/reelax-new-logo.svg"}
                    height={49}
                  />

                  <Image
                    style={{
                      position: "relative",
                      bottom: 32,
                      left: 11,
                    }}
                    source={"../assets/images/Vector.png"}
                    height={15}
                    width={10}
                  />

                  <CustomText
                    h1
                    fontSize={"font_size_h1"}
                    text={`Verify your email`}
                    textColor={"text_color_light"}
                    fontWeight={"rubik_regular"}
                  />
                </div>

                <div className="m-t-8">
                  <CustomText
                    p
                    fontSize={"font_size_small"}
                    text={`New password sent to your registered email address check your mail box`}
                    textColor={"text_color_light"}
                    fontWeight={"rubik_regular"}
                  />
                  <div className="flex-col-start">
                    <div>
                      <CustomText
                        h1
                        fontSize={"font_size_h1"}
                        text={`Your password has been changed`}
                        textColor={"text_color_primary"}
                        fontWeight={"rubik_regular"}
                      />
                    </div>
                    <div className="m-t-8">
                      <CustomText
                        p
                        fontSize={"font_size_small"}
                        text={`New password sent to your registered email address check your mail box`}
                        textColor={"text_color_primary"}
                        fontWeight={"rubik_regular"}
                      />
                      {/* <div className="flex-row">
                        <div>
                          <CustomText
                            p
                            fontSize={"font_size_small"}
                            text={email}
                            textColor={"text_color_primary"}
                            fontWeight={"rubik_regular"}
                          />
                        </div>
                        <div className="p-l-15">
                          <UnderLinedLinkCta
                            fontSize={"font_size_small"}
                            textColor={"text_color_register"}
                            text={"Change"}
                            onClick={() => {
                              navigate("/forgot-password");
                            }}
                          />
                        </div>
                      </div> */}
                    </div>

                    <div className="m-t-16">
                      <OtpInput
                        className="otp-box"
                        inputStyle={{
                          height: "54px",
                          width: "54px",
                          borderRadius: "8px",
                          border: "1px solid #4A4A4A",
                          background: "#E6E7E8",
                          color: "#3A3B43",
                          marginRight: "5px",
                        }}
                        value={otp}
                        onChange={sendOtp}
                        numInputs={6}
                        // type="number"
                        // renderSeparator={<span>-</span>}
                        renderInput={(props) => <input {...props} />}
                      />
                    </div>

                    <div className="m-t-32 full-width">
                      <PrimaryCta
                        fontSize={"font_size_large"}
                        fullWidth={true}
                        text={"Enter OTP"}
                        disabled={Utils.isNullOrUndefined(otp)} // || !sent_notification
                        isLoading={loading}
                        onClick={() => {
                          postVerifyForgotPassword(updateProgress);
                        }}
                      />
                    </div>
                    {/* <div className="resent-email m-t-16">
                      <CustomText
                        p
                        fontSize={"font_size_small"}
                        text={`Didn’t received the code?`}
                        textColor={"text_color_primary"}
                        fontWeight={"rubik_regular"}
                      />

                      <UnderLinedLinkCta
                        fontSize={"font_size_small"}
                        textColor={"text_color_register"}
                        text={"Click to resend"}
                        onClick={() => {
                          forgotPassword(updateProgress);
                        }}
                      />
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
